import(/* webpackMode: "eager" */ "/vercel/path0/apps/thesiadgroup/src/app/error.tsx");
